import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Play Stroke
 */

export default function PlayStrokeIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM6.77735 4.51823C6.44507 4.29671 6 4.53491 6 4.93426V11.0657C6 11.4651 6.44507 11.7033 6.77735 11.4818L11.376 8.41603C11.6728 8.21811 11.6728 7.78189 11.376 7.58397L6.77735 4.51823Z"
        fillRule="evenodd"
      />
    </Icon>
  );
}
